/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Pro_DescInputs */

const en_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For serious job seekers ready to stand out.`)
};

const de_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für ambitionierte Jobsuchende, die herausstechen möchten.`)
};

const fr_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les chercheurs d'emploi sérieux prêts à se démarquer.`)
};

const es_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para buscadores de empleo serios listos para destacar.`)
};

const it_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per chi cerca lavoro seriamente pronto a distinguersi.`)
};

const nl_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor serieuze sollicitanten die willen opvallen.`)
};

const pl_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla poważnych poszukujących pracy gotowych się wyróżnić.`)
};

const fi_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaarallisten työnhakijoiden valmiina erottumaan.`)
};

const da_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For alvorlige jobsøgende, der er klar til at skille sig ud.`)
};

const sv_settings_pro_desc = /** @type {(inputs: Settings_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För allvarliga jobbsökande som är redo att sticka ut.`)
};

/**
* | output |
* | --- |
* | "For serious job seekers ready to stand out." |
*
* @param {Settings_Pro_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_pro_desc = /** @type {((inputs?: Settings_Pro_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Pro_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_pro_desc(inputs)
	if (locale === "fr") return fr_settings_pro_desc(inputs)
	if (locale === "es") return es_settings_pro_desc(inputs)
	if (locale === "it") return it_settings_pro_desc(inputs)
	if (locale === "nl") return nl_settings_pro_desc(inputs)
	if (locale === "pl") return pl_settings_pro_desc(inputs)
	if (locale === "fi") return fi_settings_pro_desc(inputs)
	if (locale === "da") return da_settings_pro_desc(inputs)
	if (locale === "sv") return sv_settings_pro_desc(inputs)
	return en_settings_pro_desc(inputs)
});